// extracted by css-extract-rspack-plugin
export default {"wrapper":"_d767fad2","icon":"_fa22714a","text":"_65f7571c","zeroPadding":"_28812fb2","printHide":"_3160ed0","blurbTitle":"_e79494aa","blurbDetail":"_b6b699fb"};